var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEdit(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 18,
    viewBox: "0 0 15 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.0627 16.1948H0.941193C0.692618 16.1948 0.454224 16.2899 0.278455 16.4592C0.102686 16.6284 0.00393923 16.858 0.00393923 17.0974C0.00393923 17.3368 0.102686 17.5664 0.278455 17.7356C0.454224 17.9049 0.692618 18 0.941193 18H14.0627C14.3113 18 14.5497 17.9049 14.7255 17.7356C14.9013 17.5664 15 17.3368 15 17.0974C15 16.858 14.9013 16.6284 14.7255 16.4592C14.5497 16.2899 14.3113 16.1948 14.0627 16.1948ZM0.941193 14.3896H1.02555L4.93389 14.0466C5.36203 14.0055 5.76246 13.8238 6.06797 13.5321L14.5033 5.40864C14.8307 5.07554 15.0076 4.63105 14.9953 4.17255C14.983 3.71405 14.7825 3.27894 14.4376 2.96257L11.8696 0.48943C11.5344 0.186241 11.0952 0.012275 10.6355 0.000625288C10.1758 -0.0110245 9.72774 0.140455 9.37648 0.426248L0.941193 8.54971C0.63824 8.84393 0.449608 9.22955 0.406958 9.64186L0.00393923 13.4057C-0.00868655 13.5379 0.00912631 13.6712 0.0561079 13.796C0.103089 13.9208 0.178083 14.0341 0.275743 14.1278C0.36332 14.2115 0.467183 14.2777 0.581375 14.3226C0.695568 14.3675 0.817844 14.3903 0.941193 14.3896ZM10.5668 1.75308L13.1255 4.2172L11.251 5.97728L8.73914 3.55829L10.5668 1.75308ZM2.22523 9.7953L7.50197 4.74973L10.0326 7.18677L4.78393 12.2414L1.97217 12.4941L2.22523 9.7953Z",
    fill: "#4C4848"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEdit);
export default __webpack_public_path__ + "static/media/edit.31f0b037e3a5b9fc10b9a64ca0b4dd82.svg";
export { ForwardRef as ReactComponent };